function o(r) {
  "@babel/helpers - typeof";
  return o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, o(r);
}
function f(r, t) {
  if (o(r) != "object" || !r) return r;
  var e = r[Symbol.toPrimitive];
  if (e !== void 0) {
    var n = e.call(r, t || "default");
    if (o(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(r);
}
function y(r) {
  var t = f(r, "string");
  return o(t) == "symbol" ? t : t + "";
}
function d(r, t, e) {
  return (t = y(t)) in r ? Object.defineProperty(r, t, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : r[t] = e, r;
}
function i(r, t) {
  (t == null || t > r.length) && (t = r.length);
  for (var e = 0, n = Array(t); e < t; e++) n[e] = r[e];
  return n;
}
function c(r, t) {
  if (r) {
    if (typeof r == "string") return i(r, t);
    var e = {}.toString.call(r).slice(8, -1);
    return e === "Object" && r.constructor && (e = r.constructor.name), e === "Map" || e === "Set" ? Array.from(r) : e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e) ? i(r, t) : void 0;
  }
}
function s(r, t) {
  if (r == null) return {};
  var e = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (t.indexOf(n) >= 0) continue;
    e[n] = r[n];
  }
  return e;
}
function v(r, t) {
  if (r == null) return {};
  var e, n, u = s(r, t);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(r);
    for (n = 0; n < a.length; n++) e = a[n], t.indexOf(e) >= 0 || {}.propertyIsEnumerable.call(r, e) && (u[e] = r[e]);
  }
  return u;
}
function l() {
  return l = Object.assign ? Object.assign.bind() : function(r) {
    for (var t = 1; t < arguments.length; t++) {
      var e = arguments[t];
      for (var n in e) ({}).hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }, l.apply(null, arguments);
}
function b(r) {
  if (Array.isArray(r)) return i(r);
}
function p(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function m() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function g(r) {
  return b(r) || p(r) || c(r) || m();
}
export {
  v as _,
  g as a,
  l as b,
  d as c,
  c as d,
  o as e,
  y as t
};
